import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

document.addEventListener('DOMContentLoaded', () => {
    const htsSection = document.querySelectorAll('.horizontal-tabbed-section');

    htsSection.forEach(section => {
        const htsTabSlider = section.querySelector('.hts-tab-slider');
        const htsContentSlider = section.querySelector('.hts-content-slider');

        let mainhtsTabSlider;

        // Tabs Swiper
        if (htsTabSlider) {
            mainhtsTabSlider = new Swiper(htsTabSlider, {
                slidesPerView: 'auto',
                spaceBetween: 20,
                slideToClickedSlide: true,
                watchSlidesProgress: true,
                touchStartPreventDefault: false,
                preventClicks: false,
                preventClicksPropagation: false,
                simulateTouch: true,
                threshold: 5,
                breakpoints: {
                    768: {
                        centeredSlides: false,
                    },
                },
                on: {
                    click: function() {
                        const clickedIndex = this.clickedIndex;
                        this.slideTo(clickedIndex);
                    },
                },
            });
        }

        // Only initialize the content slider if there is a tab slider
        if (htsContentSlider) {
            new Swiper(htsContentSlider, {
                spaceBetween: 10,
                slidesPerView: 1,
                effect: 'fade',
                autoHeight: true,
                allowTouchMove: false,
                fadeEffect: {
                    crossFade: true,
                },
                thumbs: {
                    swiper: mainhtsTabSlider ? mainhtsTabSlider : null, // Ensure it's not null before passing
                },
            });
        }
    });
});